import { t } from '@lingui/core/macro';

interface LoadingScreenProps {
  message?: string;
}

function LoadingScreen({ message }: LoadingScreenProps) {
  return (
    <div className="flex-center bg-surface-primary h-screen w-full">
      <div className="text-center">
        <div className="border-surface-hover border-t-primary mb-4 inline-block h-8 w-8 animate-spin rounded-full border-4"></div>
        <p className="text-copy-secondary">{message || t`Loading...`}</p>
      </div>
    </div>
  );
}

export default LoadingScreen;
